import { combineEpics } from 'redux-observable';
import { fetchAppointmentServiceTypes } from 'modules/appointmentServiceTypes/epics/fetchAppointmentServiceTypes$';

export default combineEpics(fetchAppointmentServiceTypes);
